import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { getLNIDlistRespModel } from "../../Models/tableDetailsModel";
import moment from 'moment';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#3B78CE",
    color: theme.palette.common.white,
    padding: "7px 16px",
    maxHeight: "38px !important"
  },
  [`&.${tableCellClasses.body}`]: {
    padding: "8.5px 20px",
    fontSize: "15px",
    fontWeight: "500",
    color: "#000000",
  },
  "&.sticky-column": {
    position: "sticky",
    right: 0,
    zIndex: 1,
    backgroundColor: "#3B78CE",
    color: "white"
  }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: "#04385d0d",
  borderTop: "5px solid #fff"
  //   "&:nth-of-type(odd)": {
  //     backgroundColor: "rgba(4, 56, 93, 0.05)"
  //   }
}));
const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#3B78CE",
  color: "#fff",
  borderRadius: "5px",
  height: "28px",
  width: "73px"
}));

function createData(
  username: string,
  timestamp: string,
  status: string,
) {
  return { username, timestamp, status };
}

const rows = [
  createData("Karl Dussen", "17-02-2022 08:35PM", "Submitted"),
  createData("Tim Foster", "17-02-2022 08:35PM", "Submitted"),
  createData("Henry Klassen", "16-02-2022 08:35PM", "Draft"),
  createData("Fenny Farmer", "15-02-2022 08:35PM", "Submitted")
];

export default function TableComponent(props: any) {
  const convertUTCDateToLocalDate = (date: any) => {
    var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    return newDate;
  }
  const convertTimeToMST = (updatedOn: string) => {
    const utcDateTime = moment.utc(updatedOn);
    const mstDateTime = utcDateTime.subtract(7, 'hours');
    const formattedDateTime = mstDateTime.format('YYYY-MM-DD hh:mm:ss A');
    return formattedDateTime;
  };

  React.useEffect(() => {
    console.log("change in rows")
  }, [props.rows])
  console.log("props", props)
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell sx={{ paddingLeft: "50px !important" }} align="left">Email</StyledTableCell>
            <StyledTableCell align="center">Timestamp</StyledTableCell>
            <StyledTableCell sx={{ paddingRight: "50px !important" }} align="right">Status</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.rows?.map((row: getLNIDlistRespModel) => (
            <StyledTableRow key={row.updatedBy}>
              <StyledTableCell sx={{ paddingLeft: "50px !important" }} component="th" scope="row">
                {row.updatedBy == null ? "-" : row.updatedBy}
              </StyledTableCell>
              <StyledTableCell align="center">
                {/* @ts-ignore */}
                {row.updatedOn !== null && convertTimeToMST(row.updatedOn)} (MST)
                {/* new Date(convertUTCDateToLocalDate(new Date(row.updatedOn))).toLocaleString()} */}
              </StyledTableCell>
              <StyledTableCell sx={{ paddingRight: "50px !important" }} align="right">{row.currentStatus !== null && row.currentStatus.toLocaleString()}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
